import React from "react"
import Lottie from "lottie-react"

import myAnimation from "../../../static/animations/loading.json"

const Loader = () => (
  <div className="loader-wrapper">
    <div className="loader-spinner" style={{ width: "120px", height: "120px" }}>
      <Lottie
        animationData={myAnimation}
        loop={true} // true = anima infinitamente
        autoplay={true} // true = inicia automático
      />
    </div>
  </div>
)

export default Loader
